export const CALL_MESSAGE_NOTIFICATION = "CALL_MESSAGE_NOTIFICATION";
export const FETCH_ALL_MESSAGE_NOTIFICATIONS =
    "FETCH_ALL_MESSAGE_NOTIFICATIONS";

const setCallMessageNotification = (data) => ({
    type: CALL_MESSAGE_NOTIFICATION,
    payload: { data },
});

const setMessageNotications = (data) => ({
    type: FETCH_ALL_MESSAGE_NOTIFICATIONS,
    payload: { data },
});

//GET FROM DISPATCH

export const callMessageNotification = (data) => async (dispatch) => {
    try {
        dispatch(setCallMessageNotification(data));
    } catch (error) {
        console.log(error);
    }
};

export const getMessageNotications = (data) => (dispatch) => {
    dispatch(setMessageNotications(data));
};
